import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { AudioToTextService } from '../../services/audio-to-text/audio-to-text.service';
import { MIC_PERMISSION_OVERLAY_STYLES } from './mic-permission-overlay.styles';

@Component({
    selector: 'app-mic-permission-overlay',
    imports: [AsyncPipe],
    templateUrl: './mic-permission-overlay.component.html',
    styles: [MIC_PERMISSION_OVERLAY_STYLES]
})
export class MicPermissionOverlayComponent {
    constructor(public attService: AudioToTextService) { }

    public reload() {
        window.location.reload();
    }
}
